export default __webpack_public_path__ + "static/media/img_logo.247cafcd.png";